import React, { useState } from "react";
import { Button, message } from "antd";
import { BusinessTask } from "../BusinessTask/BusinessTask";
import { ConfirmationModal, FindDoerModal } from "../../Tasks/ActionModals";
import { FormValues } from "../../../../components/FindDoerModalContent/FindDoerDetailsContent/FindDoerDetailsContent";
import {
  useGetBusinessCities,
  useGetBusinessSkills,
} from "../../../../services/business/catalog";
import { useGetBusinessDoers } from "../../../../services/business/doer";
import { useGetBusinessDoerDetails } from "../../../../services/business/doer/useGetBusinessDoerDetails";
import { BusinessTaskDetails } from "../../../../services/business/task/useGetBusinessTaskDetails";
import { useAssignBusinessTask } from "../../../../services/business/task/useAssignBusinessTask";
import { useCancelBusinessTask } from "../../../../services/business/task/useCancelBusinessTask";

type IncomingBusinessTaskWrapperProps = {
  businessTask: BusinessTaskDetails;
  businessTaskId?: string;
  refetchBusinessTask: any;
};

export const IncomingBusinessTaskWrapper: React.FC<
  IncomingBusinessTaskWrapperProps
> = ({ businessTask, businessTaskId, refetchBusinessTask }) => {
  const [cancelModalOpen, setCancelModalOpen] = useState<boolean>(false);
  const [findDoerModalOpen, setFindDoerModalOpen] = useState<boolean>(false);

  const { mutate: assignBusinessTask, isLoading: assignBusinessTaskLoading } =
    useAssignBusinessTask();

  const { mutate: cancelBusinessTask, isLoading: cancelBusinessTaskLoading } =
    useCancelBusinessTask();

  const onBusinessTaskAssignSuccess = () => {
    setFindDoerModalOpen(false);
    refetchBusinessTask().catch((err: Error) => {
      message.error(err);
    });
  };

  const handleBusinessTaskAssign = (
    formValues: FormValues,
    doerId?: string,
  ) => {
    if (businessTaskId && doerId) {
      assignBusinessTask(
        {
          taskId: businessTaskId,
          doerId,
          materialPrice: formValues?.materialPrice,
          doerPrice: formValues?.doerPrice,
          companyProfit: formValues?.companyProfit,
        },
        {
          onSuccess: onBusinessTaskAssignSuccess,
          onError: () => {
            message.error("დაფიქსირდა შეცდომა");
          },
        },
      );
    }
  };

  const onCancelTaskSuccess = () => {
    setCancelModalOpen(true);
    refetchBusinessTask().catch((err: Error) => {
      message.error(err);
    });
  };

  const handleCancelTask = () => {
    cancelBusinessTask(businessTaskId, {
      onSuccess: onCancelTaskSuccess,
      onError: () => {
        message.error("დაფიქსირდა შეცდომა");
      },
    });
  };

  return (
    <BusinessTask
      businessTask={businessTask}
      refetchBusinessTask={refetchBusinessTask}
      actionButtons={
        <>
          <Button
            className={"action-button red"}
            onClick={() => setCancelModalOpen(true)}
          >
            {"დავალების გაუქმება"}
          </Button>
          <ConfirmationModal
            modalOpen={cancelModalOpen}
            setModalOpen={setCancelModalOpen}
            title={"დავალების გაუქმება"}
            confirmationText={"ნამდვილად გსურთ დავალების გაუქმება?"}
            onSubmit={handleCancelTask}
            isLoading={cancelBusinessTaskLoading}
          />
          <Button
            className={"action-button blue"}
            onClick={() => setFindDoerModalOpen(true)}
          >
            {"შემსრულებლის მოძებნა"}
          </Button>
          <FindDoerModal
            modalOpen={findDoerModalOpen}
            setModalOpen={setFindDoerModalOpen}
            onAssignTask={handleBusinessTaskAssign}
            assignTaskLoading={assignBusinessTaskLoading}
            hasAdditionalDetails={false}
            hasSplitPrice={true}
            getCities={useGetBusinessCities}
            getSkills={useGetBusinessSkills}
            getDoers={useGetBusinessDoers}
            getDoerDetails={useGetBusinessDoerDetails}
            skillsParamName={"skills"}
          />
        </>
      }
    />
  );
};
